<template>
  <layout-vertical>

    <router-view />

    <div
      slot="vertical-menu-header"
      class="d-flex align-items-center h-100 p-1"
    >
      <b-link class="brand-logo">
        <b-img
          fluid
          :src="sideImg"
          style="width: 170px"
        />
      </b-link>
    </div>

    <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    />

  </layout-vertical>
</template>

<script>
import { BImg, BLink } from 'bootstrap-vue'
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BImg,
    BLink,
    AppCustomizer,
    LayoutVertical,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      sideImg: require('@/assets/images/logo/logo.png'),
      showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>
